(function(){
'use strict';
// compare slider
document.querySelectorAll('.i4-compare').forEach(function(box){
  var range=box.querySelector('.i4-cmp-range'),top=box.querySelector('.i4-cmp-top'),bar=box.querySelector('.i4-cmp-bar'),h=box.querySelector('.i4-cmp-handle');
  function set(v){top.style.clipPath='inset(0 '+(100-v)+'% 0 0)';bar.style.left=v+'%';h.style.left=v+'%';}
  if(range){range.addEventListener('input',function(){set(+range.value)});set(+range.value);}
});
// projects <-> map hover sync (legacy dark projects section)
document.querySelectorAll('.i4-projects').forEach(function(root){
  var circles=[].slice.call(root.querySelectorAll('.i4-map-dot')),cards=[].slice.call(root.querySelectorAll('.i4-proj'));
  var nameEl=root.querySelector('.i4-active-name'),areaEl=root.querySelector('.i4-active-area');
  function activate(i){
    circles.forEach(function(c){var on=+c.getAttribute('data-i')===i;c.setAttribute('r',on?'2.4':'1.4');c.setAttribute('fill',on?'#8c786d':'#af9d93');});
    var card=cards[i];if(card&&nameEl){nameEl.textContent=card.getAttribute('data-name')||'';areaEl.textContent=card.getAttribute('data-area')||'';}
  }
  cards.forEach(function(card,i){card.addEventListener('mouseenter',function(){activate(i)});});
  circles.forEach(function(c){c.addEventListener('mouseenter',function(){activate(+c.getAttribute('data-i'))});});
  if(cards.length)activate(0);
});
// fast / good / affordable toggles
document.querySelectorAll('.i4-pick').forEach(function(root){
  var others=['fast','good'],toggles=[].slice.call(root.querySelectorAll('.i4-toggle[data-k]'));
  function render(){toggles.forEach(function(t){t.classList.toggle('is-on',others.indexOf(t.getAttribute('data-k'))>-1);});}
  toggles.forEach(function(t){t.addEventListener('click',function(){
    var k=t.getAttribute('data-k'),idx=others.indexOf(k);
    if(idx>-1)others.splice(idx,1);else{others.push(k);if(others.length>2)others.shift();}
    render();
  });});
  render();
});
// width-match helper
function i4Fit(){
  document.querySelectorAll('.i4-fitwidth').forEach(function(el){
    var scope=el.closest('h1')||document,ref=scope.querySelector('.i4-fitref');if(!ref)return;
    el.style.letterSpacing='0px';el.style.marginRight='0px';
    var refLS=parseFloat(getComputedStyle(ref).letterSpacing)||0;
    var target=ref.getBoundingClientRect().width-Math.max(refLS,0);
    var w0=el.getBoundingClientRect().width;
    var n=el.textContent.length-1;
    if(n<1||target<=w0)return;
    var L=(target-w0)/n;
    el.style.letterSpacing=L+'px';
    el.style.marginRight=(-L)+'px';
  });
}
i4Fit();
if(document.fonts&&document.fonts.ready){document.fonts.ready.then(i4Fit);}
addEventListener('load',i4Fit);
var i4rT;addEventListener('resize',function(){clearTimeout(i4rT);i4rT=setTimeout(i4Fit,120)},{passive:true});
// generic horizontal sliders
document.querySelectorAll('.i5s').forEach(function(s){
  var t=s.querySelector('.i5s-t');if(!t)return;
  function step(){var c=t.children[0];return c?c.getBoundingClientRect().width+21:320}
  var p=s.querySelector('.i5s-prev'),n=s.querySelector('.i5s-next');
  if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'})});
  if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'})});
});
// lightbox zoom
var lb=null;
function openLB(src){
  if(!lb){
    lb=document.createElement('div');lb.className='i5-lb';
    lb.innerHTML='<div class="i5-lb-scroll"><img alt="ebarza project photo"></div><button class="i5-lb-x" aria-label="Close">×</button>';
    document.body.appendChild(lb);
    function close(){lb.classList.remove('is-open','is-zoom');document.documentElement.style.overflow='';}
    lb.querySelector('.i5-lb-x').addEventListener('click',close);
    lb.querySelector('.i5-lb-scroll').addEventListener('click',function(e){if(e.target===this)close();});
    lb.querySelector('img').addEventListener('click',function(){lb.classList.toggle('is-zoom')});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  lb.querySelector('img').src=src;
  lb.classList.remove('is-zoom');lb.classList.add('is-open');
  document.documentElement.style.overflow='hidden';
}
document.addEventListener('click',function(e){
  var z=e.target.closest('[data-zoom]');
  if(z){e.preventDefault();openLB(z.getAttribute('data-zoom'));}
});
// in-view reveals: stat bars + count-up
var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
function countUp(el){
  var to=parseInt(el.getAttribute('data-to')||'0',10),sfx=el.getAttribute('data-suffix')||'';
  if(reduce){el.textContent=to.toLocaleString('en-US')+sfx;return;}
  var t0=null,dur=1400;
  function tick(ts){
    if(!t0)t0=ts;
    var k=Math.min(1,(ts-t0)/dur);k=1-Math.pow(1-k,3);
    el.textContent=Math.round(to*k).toLocaleString('en-US')+sfx;
    if(k<1)requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}
if('IntersectionObserver' in window){
  var io=new IntersectionObserver(function(es){
    es.forEach(function(en){
      if(!en.isIntersecting)return;
      en.target.classList.add('in');
      if(en.target.classList.contains('i5-count'))countUp(en.target);
      io.unobserve(en.target);
    });
  },{threshold:.3});
  document.querySelectorAll('.i5-io,.i5-count,.i5-bar').forEach(function(el){io.observe(el)});
}else{
  document.querySelectorAll('.i5-io,.i5-bar').forEach(function(el){el.classList.add('in')});
  document.querySelectorAll('.i5-count').forEach(countUp);
}
// nav behaviors
var pill=document.querySelector('.i5-nav2');
var mc=document.querySelector('.i5-mcircles');
var mburger=document.querySelector('.i5-mburger');
var mcart=document.querySelector('.i5-mcart');
var movl=document.querySelector('.i5-movl');
var logofix=document.querySelector('.i5-logofix');
var hero=document.getElementById('top');
var iT;
function lightCheck(){
  if(!hero)return;
  var light=window.scrollY>hero.offsetHeight-90;
  [pill,mc,logofix,mcart,mburger].forEach(function(el){if(el)el.classList.toggle('is-light',light)});
}
function scrollState(){
  var away=window.scrollY>40;
  if(mc)mc.classList.toggle('is-mini',away);
  var open=movl&&movl.classList.contains('is-open');
  if(mburger&&!open)mburger.classList.toggle('is-on',away);
  if(mcart&&!mcart.classList.contains('i5-always'))mcart.classList.toggle('is-on',away);
}
lightCheck();scrollState();
addEventListener('scroll',function(){
  lightCheck();scrollState();
  if(pill){
    pill.classList.add('is-mini');
    clearTimeout(iT);
    iT=setTimeout(function(){pill.classList.remove('is-mini')},420);
  }
},{passive:true});
// burger -> fullscreen overlay
if(mburger&&movl){
  mburger.addEventListener('click',function(){
    var open=movl.classList.toggle('is-open');
    mburger.classList.toggle('is-open',open);
    mburger.classList.add('is-on');
    mburger.setAttribute('aria-expanded',open);
    document.documentElement.style.overflow=open?'hidden':'';
    if(!open)scrollState();
  });
  [].forEach.call(movl.querySelectorAll('a'),function(a){
    a.addEventListener('click',function(){
      movl.classList.remove('is-open');
      mburger.classList.remove('is-open');
      document.documentElement.style.overflow='';
      scrollState();
    });
  });
}

/* Third-party widgets inject icon-only links with no accessible name (Loox's
   close button is an empty <a href="#">), which fails the accessibility tree.
   They arrive whenever their script feels like it, so label them on a short
   retry schedule after load instead of watching the whole DOM forever. */
(function(){
  var tries=0;
  function label(){
    tries++;
    [].forEach.call(document.querySelectorAll('a.loox-pn-close:not([aria-label])'),function(a){
      a.setAttribute('aria-label','Close reviews popup');
    });
    if(tries<8)setTimeout(label,1500);
  }
  if(document.readyState==='complete')setTimeout(label,1000);
  else addEventListener('load',function(){setTimeout(label,1000);});
})();
})();